import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Widget } from '@typeform/embed-react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import EmployerReferralModal from '../EmployerReferralModal';
import './NPSModal.scss';
var TYPEFORM_HEIGHT = '450px';
var TYPEFORM_WIDTH = '600px';
var NPSModal = /*#__PURE__*/function (_Component) {
  function NPSModal(props) {
    var _this;
    _classCallCheck(this, NPSModal);
    _this = _callSuper(this, NPSModal, [props]);
    _this.state = {
      showNPSModal: props.showNPSInitial,
      showReferralModal: !props.showNPSInitial
    };
    _this.closeModalAndCleanURLParams = _this.closeModalAndCleanURLParams.bind(_this);
    _this.showReferralModal = _this.showReferralModal.bind(_this);
    return _this;
  }
  _inherits(NPSModal, _Component);
  return _createClass(NPSModal, [{
    key: "closeModalAndCleanURLParams",
    value: function closeModalAndCleanURLParams() {
      window.location.href = window.location.pathname;
      this.setState({
        showNPSModal: false,
        showReferralModal: false
      });
    }
  }, {
    key: "showReferralModal",
    value: function showReferralModal() {
      this.setState({
        showNPSModal: false,
        showReferralModal: true
      });
    }
  }, {
    key: "renderTypeform",
    value: function renderTypeform() {
      var _this2 = this;
      var _this$props = this.props,
        NPSFormId = _this$props.NPSFormId,
        utmParams = _this$props.utmParams;
      if (NPSFormId) {
        return /*#__PURE__*/React.createElement("div", {
          className: "typeform-container"
        }, /*#__PURE__*/React.createElement(Widget, {
          id: NPSFormId,
          hidden: utmParams,
          style: {
            height: TYPEFORM_HEIGHT,
            width: TYPEFORM_WIDTH
          },
          onSubmit: function onSubmit() {
            return _this2.showReferralModal();
          }
        }));
      }
      return null;
    }
  }, {
    key: "renderNPSModal",
    value: function renderNPSModal() {
      var _this3 = this;
      var showNPSModal = this.state.showNPSModal;
      return /*#__PURE__*/React.createElement(Modal, {
        dialogClassName: "nps-modal",
        show: showNPSModal,
        onHide: function onHide() {
          return _this3.closeModalAndCleanURLParams();
        }
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement(Modal.Title, null, /*#__PURE__*/React.createElement("div", {
        className: "nps-modal-title-text"
      }, "We value your insights and partnership."))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        className: "non-typeform-components"
      }, /*#__PURE__*/React.createElement("div", {
        className: "nps-modal-body-text"
      }, "Your feedback is important to us and will help Clora continue to improve."), /*#__PURE__*/React.createElement("hr", {
        className: "line"
      })), this.renderTypeform()));
    }
  }, {
    key: "renderReferralModal",
    value: function renderReferralModal() {
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        referralPath = _this$props2.referralPath,
        newReferralPath = _this$props2.newReferralPath,
        shareOnLinkedinUrl = _this$props2.shareOnLinkedinUrl,
        authCodeUrl = _this$props2.authCodeUrl,
        authStatus = _this$props2.authStatus;
      var showReferralModal = this.state.showReferralModal;
      var referralHeroCopy = this.props.showNPSInitial ? 'Thanks for sharing your feedback!' : 'Congratulations on your new hire!';
      return /*#__PURE__*/React.createElement(EmployerReferralModal, {
        csrfToken: csrfToken,
        referralPath: referralPath,
        newReferralPath: newReferralPath,
        shareOnLinkedinUrl: shareOnLinkedinUrl,
        authCodeUrl: authCodeUrl,
        authStatus: authStatus,
        showModal: showReferralModal,
        onHideCallback: this.closeModalAndCleanURLParams,
        referralHeroCopy: referralHeroCopy
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.renderReferralModal(), this.renderNPSModal());
    }
  }]);
}(Component);
NPSModal.propTypes = {
  utmParams: PropTypes.shape({}),
  NPSFormId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  referralPath: PropTypes.string.isRequired,
  newReferralPath: PropTypes.string.isRequired,
  shareOnLinkedinUrl: PropTypes.string.isRequired,
  authCodeUrl: PropTypes.string,
  authStatus: PropTypes.number,
  showNPSInitial: PropTypes.bool
};
NPSModal.defaultProps = {
  utmParams: {
    utm_source: 'unknown',
    utm_medium: 'unknown',
    utm_campaign: 'unknown'
  },
  authCodeUrl: null,
  authStatus: null,
  showNPSInitial: false
};
export default NPSModal;